import React from 'react';
import Icon from 'components/AppIcon';

const AssessmentBenefits = ({ features }) => {
  const getColorClasses = (color) => {
    const colorMap = {
      primary: {
        bg: 'bg-primary-50',
        border: 'border-primary-100',
        icon: 'bg-primary-100',
        iconColor: 'var(--color-primary)',
        text: 'text-primary-600'
      },
      secondary: {
        bg: 'bg-secondary-50',
        border: 'border-secondary-100',
        icon: 'bg-secondary-100',
        iconColor: 'var(--color-secondary)',
        text: 'text-secondary-600'
      },
      accent: {
        bg: 'bg-accent-50',
        border: 'border-accent-100',
        icon: 'bg-accent-100',
        iconColor: 'var(--color-accent)',
        text: 'text-accent-600'
      }
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <div className="space-y-6">
      <div className="text-center lg:text-left">
        <h2 className="text-2xl font-heading font-semibold text-text-primary mb-3">
          What You'll Get
        </h2>
        <p className="text-text-secondary">
          Comprehensive insights and personalized recommendations for your wellness journey.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
        {features.map((feature, index) => {
          const colors = getColorClasses(feature.color);
          return (
            <div
              key={index}
              className={`${colors.bg} ${colors.border} border rounded-xl p-6 transition-all duration-200 hover:shadow-therapeutic`}
            >
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 w-12 h-12 ${colors.icon} rounded-lg flex items-center justify-center`}>
                  <Icon name={feature.icon} size={24} color={colors.iconColor} />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-text-primary mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-text-secondary leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Additional Benefits */}
      <div className="bg-surface border border-border rounded-xl p-6">
        <h3 className="font-heading font-medium text-text-primary mb-4">
          Your Assessment Includes:
        </h3>
        <div className="space-y-3">
          {[
            "Mental health and anxiety screening",
            "COVID-19 impact evaluation",
            "Lifestyle and wellness factors analysis",
            "Personalized coping strategies",
            "Professional resource recommendations",
            "Progress tracking capabilities"
          ].map((benefit, index) => (
            <div key={index} className="flex items-center space-x-3">
              <Icon name="Check" size={16} color="var(--color-success)" />
              <span className="text-sm text-text-secondary">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssessmentBenefits;